<template>
	<div class="con-1060">
		<ul class="basic-package columns-2">
			<li v-for="(list, index) in options.basicPackage" :class="['label tick', options.className]" :key="index" v-if="list.id !== 62 || getValuableSum > 0">
				{{ list.text }}
				<span v-if="list.tooltip" v-tooltip="list.tooltipText" class="info"></span>
                <div v-if="list.id === 62">
                    Fedezeti összeg: {{ (getValuableSum > 200000 ? 200000 : getValuableSum) | toCurrency }}
                </div>
			</li>
		</ul>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import {mapGetters} from "vuex";

export default {
	mixins: [shared],
    computed: {
        ...mapGetters(['getValuableSum']),
    },
};
</script>
